<div [class.h100]="isHeightFull" [class.mw700]="isReadLatterConfirm" [ngClass]="popupBodyClass" class="popup-body">
  @if (title || !hideCloseBtn) {
    <div class="pop-up-header">
      @if (title) {
        <div class="title">
          @if (!hideIcon) {
            <span class="check"><i class="icon-check1"></i></span>
            } {{ title }}
          </div>
        }
        @if (!hideCloseBtn) {
          <button (click)="onClose()" class="close" data-e2e="close-popup-btn"><i
          class="icon-close"></i></button>
        }
      </div>
    }
    <div class="scroll-container scroll">
      <div class="pop-up-content">
        <ng-template #popupContainer></ng-template>
      </div>
    </div>
  </div>
